export const API_ERROR_SET = 'API_ERROR_SET';
export const API_ERROR_RESET = 'API_ERROR_RESET';
